import { ActionCalculationMultilevel } from "./GeneralizationBlock/ActionCalculationMultilevel";
import { ActionCalculationFields } from "./ActionCalculationFields";
import { useMyActionPlanContext } from "../../context/useMyActionPlan";
import { EmptyActionInfo } from "./EmptyActionInfo";

export const ActionCalculation = () => {
    const { canBeGeneralized, isEmpty } = useMyActionPlanContext();

    if (isEmpty) {
        return <EmptyActionInfo />;
    }

    if (canBeGeneralized) {
        return <ActionCalculationMultilevel />;
    }

    return <ActionCalculationFields />;
};
